import React from 'react';

import { SvgIcon } from 'js/app/components/common/SvgIcon';
import Bullets from 'js/components/common/Slider/Bullets';

import { useTranslations } from 'js/hooks/i18n';
import * as hooks from 'js/components/common/Slider/hooks';

import style from './index.scss';

/* core, changed SvgIcon */
export const Controls = (props) => {
    const {
        sliderMove,
        sliderMoveLeft,
        sliderMoveRight
    } = hooks.useSliderNavigation(props);
    const {
        options: {
            arrows,
            bullets,
            buttons
        },
        classNames: {
            leftArrow = '',
            rightArrow = '',
            ...classNames
        } = {},
        activeSlide,
        slidesCount,
        infinite,
        isBulletsClickable
    } = props;
    const arrowsStyle = hooks.useArrowStyles(arrows);
    const bulletsClassNames = hooks.useBulletsClassNames(classNames);
    const onBulletClick = hooks.useBulletClickHandler({ activeSlide, sliderMove });
    const translate = useTranslations('playtech.mobile.system.slider.');

    return (
        <>
            {(bullets.enabled || buttons.enabled) && (
                <Bullets
                    activeSlide={activeSlide}
                    count={slidesCount}
                    showNumbers={buttons.enabled}
                    position={bullets.position}
                    classNames={bulletsClassNames}
                    onClick={onBulletClick}
                    isBulletsClickable={isBulletsClickable}
                />)
            }
            {arrows.enabled && !(!infinite && activeSlide === 0) && (
                <SvgIcon
                    style={arrowsStyle}
                    onClick={sliderMoveLeft}
                    type='arrow-left'
                    aria-label={translate('aria-label.leftArrowButton')}
                    className={`${style.leftArrow} ${classNames.arrows || ''} ${leftArrow}`}
                />)
            }
            {arrows.enabled && !(!infinite && activeSlide === slidesCount - 1) && (
                <SvgIcon
                    style={arrowsStyle}
                    onClick={sliderMoveRight}
                    type='arrow-right'
                    aria-label={translate('aria-label.rightArrowButton')}
                    className={`${style.rightArrow} ${classNames.arrows || ''} ${rightArrow}`}
                />)
            }
        </>
    );
};

export default Controls;
